module.exports = __webpack_public_path__ + "fonts/fa-solid-900.fb2f4531.woff";